import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=8b163aa0&scoped=true&"
import script from "./SystemConfig.vue?vue&type=script&lang=ts&"
export * from "./SystemConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b163aa0",
  null
  
)

export default component.exports